const AportacionesODepositosRules = ( data = {} ) => {

  const { TipoAportacionODeposito, MontAportODep } = data;

  let TipoAportacionODepositoRule = 'string';
  let MontAportODepRule = 'numeric';

  if (!!TipoAportacionODeposito || !!MontAportODep) {
    MontAportODepRule = 'required';
    TipoAportacionODepositoRule = 'required';
  }

  return {
    TipoAportacionODeposito: [
      TipoAportacionODepositoRule,
      'string',
      'in:a,b,c',
    ],
    MontAportODep: [
      MontAportODepRule,
      'decimal:6',
    ],
    RFCFiduciaria: [
      'string',
      'min:12',
      'max:13',
    ],
  }
};

export default AportacionesODepositosRules;
